export const CART_KEY = 'pick-cart';
export const WEB_CART_KEY = 'web-cart';
export const CART_ID_KEY = 'cartId';
export const TOKEN = 'token';
export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_PERMISSIONS = 'auth_permissions';
export const LIMIT = 10;
export const SUPER_ADMIN = 'super_admin';
export const CUSTOMER = 'customer';
export const CHECKOUT = 'kidslabs-checkout';
export const SHOPS_LIMIT = 20;
export const RTL_LANGUAGES: ReadonlyArray<string> = ['ar', 'he'];
export const PRODUCT_INITIAL_FETCH_LIMIT = 30;
export const DEFAULT_LANGUAGE = process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE ?? 'en';
export const SHIPPING_CART_ADDRESS = 'shipping_cart_address';
export const CART_ADDRESS_INPUT = 'CartAddressInput';
export const CHECKOUT_SELECTED_CUSTOMER_ADDRESS = 'checkout_selected_customer_address';
export const MAGENTO_SECURE_API_SESSION = '__Secure-API_SESSION';
export const MAGENTO_COOKIE_STORE_CODE = 'store';
export const MAGENTO_PERSISTENT_SHOPPING_CART_KEY = 'persistent_shopping_cart';
export const MAGENTO_TOKEN_SESSION_KEY = 'magento-token-session';
export const MAGENTO_STORE_CODE_KEY = 'magento-store-code';
export const MAGENTO_HTTP_X_MOBILE_APP_KEY = 'HTTP_X_MOBILE_APP';
export const X_API_KEY_HEADER_KEY = 'X-API-KEY';
export const SECURE_COOKIE_SESSION_TOKEN_KEY = '__Secure-SID';
export const SECURE_COOKIE_SESSION_TOKEN_KEY_LOCAL = 'LOCAL__Secure-SID';
export const MAGENTO_PHPSESSID = 'PHPSESSID';
export const EMAIL = 'EMAIL';
export const PRODUCT_REVIEW_PAGE_SIZE = 5;
export const CHECKOUT_ORDER_NUMBER = 'checkout_order_number';
export const CHECKOUT_ORDER_STATUS = 'checkout_order_status';
export const CHECKOUT_ORDER_IS_CALLBACK = 'checkout_order_is_callback';
export const VIEWED_PRODUCT_KEY = 'viewed_products';
export const PRODUCT_NOTIFICATION_IDS_KEY = 'notification_ids_product';
export const KIDSPLAZA_V2_ASSETS_BASE_URL = `${process.env.NEXT_PUBLIC_CDN_BASE_URL ?? ''}/assets`;
export const ZALO_CHAT_LINK = 'https://zalo.me/2749650043063337701';
export const DEFAULT_MAX_ITEMS_PER_ROW_SWIPER = 20;
export const TEMPORARY_PURCHASE_DATA_KEY = 'temporary_purchase_data';
export const PAYMENT_IN_PROGRESS_SHOPEE = 'payment_in_progress_shopee'
export const X_CART_ITEMS_KEY = 'xCartItems';

export function getDirection(language: string | undefined) {
    if (!language) return 'ltr';
    return RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
}

export enum CheckoutStep {
    customerInfo = 1,
    shippingAddress = 2,
    payment = 3,
}

export const stepRoute = {
    '#login-information': 1,
    '#shipping': 2,
    '#payment': 3,
};

export const ProductQueryParams = {
    SORTING: 'product_list_order',
    DIRECTION: 'direction',
    PAGINATION: 'p',
    SEARCH: 'q',
    SIGN: 'sign',
} as const;

export enum BannerPosition {
    MAIN_BANNER = 'home-page.page-top-main-banner',
    SUB_BANNER = 'home-page.page-top-sub-banner',
    MID_HOME_PAGE_BANNER = 'home-page.page-middle-center-banner',
}

export enum FestivalRegisterStep {
    selectRegion = 1,
    registerInfo = 2,
    selectEvent = 3,
    qrCode = 4,
}

export enum FestivalRegisterStepTitle {
    SELECT_REGION = 'SELECT_REGION',
    REGISTER_INFO = 'REGISTER_INFO',
    SELECT_EVENT = 'SELECT_EVENT',
    SUCCESS_PAGE = 'SUCCESS_PAGE',
}
